/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsUpdate } from "../../funcs/tenantsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsRequestBody$inboundSchema,
};

export const tool$tenantsUpdate: ToolDefinition<typeof args> = {
  name: "tenants_update",
  description: `Update tenant details

Updates the configuration of a specific tenant`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
